export default "__VITE_ASSET__9afGlY2V__"